import React from 'react';
import { Heading, HeadingProps } from 'src/components/common/Heading/Heading';
import { Icon } from 'src/components/common/Icon/Icon';
import styles from './Drawer.module.scss';
import cn from 'classnames';

interface DrawerProps {
  isOpen: boolean;
  onClose: (e: React.MouseEvent<HTMLButtonElement>) => void;
  title: string | HeadingProps & { text: string };
  dissmisable?: boolean;
  position: 'left' | 'right';
  smallPadding?: boolean;
}

export const Drawer: React.FC<DrawerProps> = ({ onClose, isOpen, children, title, position, smallPadding }) => {

  if (!isOpen) return null;

  return (
    <div
      className={cn(styles['o-drawer'], {
        [styles[`o-drawer--${position}`]]: position,
        [styles['o-drawer--small-padding']]: smallPadding,
      })}
    >
      <button type="button" onClick={onClose} className={styles['o-drawer__close']} aria-label="Close sidebar">
        <Icon name="XIcon" size={24} />
      </button>
      <aside className={styles['o-drawer__side']}>
        <div className={styles['o-drawer__content']}>
          {typeof title === 'string'
            ? <Heading size="h2" className={styles['o-drawer__content-title']}>{title}</Heading>
            : (
              <Heading
                size={title.size}
                as={title.as}
                className={cn(styles['o-drawer__content-title'], title.className)}
              >
                {title.text}
              </Heading>
            )
          }
          {children}
        </div>
      </aside>
    </div>
  );
};
